import React, { FC } from 'react';

import { Image } from '@lglp/components';
import { LinkType } from '@lglp/prismic-client';
import { useTranslation } from 'react-i18next';

import { HEADER } from 'translations';

import { ROUTE_KEY, getUrlForRouteKey } from '../../../config/routes';
import { LA_POSTE_LOGO } from '../../../helpers/assets';
import { LinkedComponent } from '../../LinkedComponent';
import styles from './HeaderLogo.module.scss';

export const HeaderLogo: FC = () => {
  const { t, i18n } = useTranslation();

  return (
    <LinkedComponent
      className={styles.home}
      link={{
        linkType: LinkType.Web,
        url: getUrlForRouteKey(ROUTE_KEY.HOME, i18n.language),
      }}
    >
      <Image
        className={styles.logo}
        src={LA_POSTE_LOGO}
        alt={t(HEADER.LOGO_ALTERNATIVE_TEXT)}
      />
    </LinkedComponent>
  );
};
